import React from 'react';

import { Box, Stack, Typography } from '@mui/material';
import CustomButton from 'components/Button/CustomButton';

import { StyledButton } from './styled';
import moment from 'moment-timezone';
import { getTimeZone } from 'utils/globalFunction';

interface PropTypes {
  handleCancel?: () => void;
  handleSubmit?: () => void;
  loading?: boolean;
  isEditing?: boolean;
  checklistLog?: any;
}

const Footer = ({
  handleCancel,
  handleSubmit,
  isEditing = false,
  loading,
  checklistLog,
}: PropTypes) => {
  const tz: string = getTimeZone();
  return (
    <Stack
      direction={'row'}
      justifyContent={'flex-end'}
      borderTop={'1px solid #E0E0E0'}
      p="20px 24px"
      gap="16px"
      mt="auto"
    >
      {isEditing && (
        <Box mr={'auto'}>
          <Typography
            sx={{
              fontSize: '13px',
              color: '#000',
              fontWeight: 500,
            }}
          >
            Submitted on:
          </Typography>
          <Typography
            sx={{
              fontSize: '14px',
              color: '#000',
              fontWeight: 700,
            }}
          >
            {moment
              .tz(checklistLog?.updatedAt, tz)
              .format('MMM DD, YYYY • hh:mm A')}
          </Typography>
        </Box>
      )}

      <StyledButton
        disabled={loading}
        onClick={handleCancel}
        variant="outlined"
      >
        Cancel
      </StyledButton>
      <StyledButton
        disabled={loading}
        onClick={handleSubmit}
        variant="contained"
      >
        {isEditing ? 'Save Changes' : 'Submit'}
      </StyledButton>
    </Stack>
  );
};

export default Footer;
